import { Card, Divider } from "antd";
import { CircleCheck, ClipboardCheck, Target, TrendingUp } from "lucide-react";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import PerformanceHeader from "./PerformanceHeader";
import InfractionsSummary from "./InfractionsSummary";
import RecentIncidentSummary from "./RecentIncidentSummary";
import ComplianceStatus from "./ComplianceStatus";


const HRComplianceStanding = ( props ) => {
  const {} = props;


  	return (
      <PerformanceHeader
          title="HR Compliance & Standing"
          description="Employee conduct and policy compliance"
					icon={<CircleCheck size={20}/>}
          cardTheme="white-green"
          rightNav="Good Standing"
      >
<div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <InfractionsSummary/>
        <RecentIncidentSummary/>
        <ComplianceStatus/>
</div>


      </PerformanceHeader>
);
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(HRComplianceStanding);
